<template>
	<v-dialog v-model="dialog" width="500px">
		<template #activator="{ on }">
			<v-btn dark text small :disabled="isUserContact" v-on="on"
				>Change Photo</v-btn
			>
		</template>

		<v-card>
			<v-card-title>Change the profile photo</v-card-title>
			<v-card-text class="d-flex flex-column">
				<v-image-input
					v-model="croppedImage"
					:debounce="100"
					clear-icon="$clear"
					upload-icon="fa-file-upload"
					flip-horizontally-icon="fa-arrows-alt-h"
					flip-vertically-icon="fa-arrows-alt-v"
					rotate-clockwise-icon="fa-redo-alt"
					rotate-counter-clockwise-icon="fa-undo-alt"
					clearable
				/>
			</v-card-text>
			<v-alert v-if="hasError" class="ma-0" type="error" text dense v-text="hasError" />
			<v-card-actions class="justify-end">
				<v-btn text @click="dialog = false">Cancel</v-btn>
				<v-btn
					text
					color="success"
					:disabled="!croppedImage"
					:loading="loading"
					@click="handleSubmit()"
					>Submit</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import VImageInput from "vuetify-image-input/a-la-carte";

export default {
	components: {
		VImageInput,
	},

	data() {
		return {
			loading: false,
			hasError: false,
			dialog: false,
			croppedImage: null,
		};
	},

	computed: {
		...mapGetters("userEdit", ["type", "profileImage"]),

		userId() {
			return this.$route.params.userId;
		},

		isUserContact() {
			return this.type && this.type === "Contact";
		},
	},

	watch: {
		dialog(val) {
			if (!val) this.cancelChangePhoto();
		},
	},

	methods: {
		...mapActions("userEdit", ["setProfileImage"]),

		cancelChangePhoto() {
			this.croppedImage = null;
			this.hasError = false;
		},

		async handleSubmit() {
			if (this.loading) return;
			this.loading = true;

			const res = await this.setProfileImage({
				id: this.userId,
				image: this.croppedImage,
			});

			if (res.error) {
				this.hasError = res.error;
			} else {
				this.$emit("success");
				this.dialog = false;
			}

			this.loading = false;
		},
	},
};
</script>
